import React, { useEffect, useState } from 'react';
import { Pencil } from 'lucide-react';
import { Button } from '@/components/ui/button';
import apiClient from '@/utils/api';
import { PROFILE_SECTIONS, displayValue, humanize } from './profileFields';

export const ProfileDetails = ({ student, onEdit }) => {
  const [interests, setInterests] = useState([]);
  useEffect(() => {
    let active = true;
    apiClient.get(`/workflow/leads/${student.id}/interests`).then(r => {
      if (active) setInterests(r.data.interests || []);
    }).catch(() => {});
    return () => { active = false; };
  }, [student.id]);
  const additional = interests.filter(i => !i.is_primary || i.country !== student.desired_country || i.course !== student.desired_course);
  return <div className="divide-y divide-gray-200" data-testid="student-details-sections">
    {PROFILE_SECTIONS.map(section => {
      return <section className="py-4 first:pt-0" key={section.id} data-testid={`profile-section-${section.id}`}>
        <div className="flex items-center justify-between gap-3 mb-3">
          <h2 className="text-base font-semibold text-gray-900" data-testid={`profile-section-heading-${section.id}`}>{section.title}</h2>
          <Button variant="ghost" size="sm" className="min-h-[44px] shrink-0" onClick={() => onEdit(section.id)} data-testid={`edit-section-${section.id}`} aria-label={`Edit ${section.title}`}><Pencil className="w-4 h-4 mr-2" />Edit</Button>
        </div>
        <dl className="grid grid-cols-1 min-[360px]:grid-cols-2 gap-x-5 gap-y-3">
          {section.fields.map(([key, label]) => <div key={key} className="min-w-0" data-testid={`profile-value-${key}`}>
            <dt className="text-xs text-gray-500 mb-1">{label}</dt>
            <dd className="text-sm text-gray-900 break-words whitespace-pre-wrap">{displayValue(student, key) === '' || displayValue(student, key) == null ? <span className="text-gray-500">Not provided</span> : String(displayValue(student, key))}</dd>
          </div>)}
        </dl>
        {section.id === 'contact' && student.date_of_birth && <AgeNotice dob={student.date_of_birth} />}
        {section.id === 'study' && additional.length > 0 && <details open className="mt-4" data-testid="profile-other-interests">
          <summary className="text-sm text-gray-500 min-h-[44px] flex items-center cursor-pointer" data-testid="profile-interest-history-toggle">Alternative / previous interests ({additional.length})</summary>
          {additional.map(i => <p className="text-sm break-words py-1" key={i.id} data-testid={`profile-interest-${i.id}`}>{i.country || 'Country not specified'} · {i.course || 'Course not specified'} <span className="text-xs text-gray-500">({humanize(i.status)})</span></p>)}
        </details>}
      </section>;
    })}
  </div>;
};

const AgeNotice = ({ dob }) => {
  const birth = new Date(dob), today = new Date();
  if (Number.isNaN(birth.getTime()) || birth > today) return null;
  let age = today.getFullYear() - birth.getFullYear();
  if (today.getMonth() < birth.getMonth() || (today.getMonth() === birth.getMonth() && today.getDate() < birth.getDate())) age--;
  if (age >= 18) return null;
  const turns18 = new Date(birth.getFullYear() + 18, birth.getMonth(), birth.getDate());
  return <p className="mt-3 text-sm text-amber-800" data-testid="minor-badge">Minor · {age} years · Turns 18 in {Math.ceil((turns18 - today) / 86400000)} days</p>;
};